import React, { useState } from 'react';
import { Importer, ImporterField } from 'react-csv-importer';
import { submitOverrideCommision } from '../../../../API';

interface Props {
  date: Date;
}

export interface OverrideCommissionRow {
  day: string;
  sku: string;
  commission_amount: number;
}

const CSVImporterOverrideCommission = (props: Props) => {
  console.log('date', props.date);

  const [rows, setRows] = useState<OverrideCommissionRow[]>([]);

  const handleDataRows = (r: any[]) => {
    const sanitised: OverrideCommissionRow[] = r
      .map((e) => ({
        day: e.day,
        sku: e.sku,
        commission_amount: parseFloat(e.commission_amount.replace(',', '')),
      }))
      .filter((e) => e.day && e.commission_amount > 0 && e.sku);
    setRows((rows) => rows.concat(sanitised));
  };

  const handleComplete = async () => {
    // run importer

    const year = props.date.getFullYear();
    const month = (props.date.getMonth() + 1).toString().padStart(2, '0');
    const date = year + month;

    console.log('input', { date, rows });

    await submitOverrideCommision(rows, date);
  };

  return (
    <Importer
      dataHandler={(rows, { startIndex }) => {
        handleDataRows(rows);
      }}
      defaultNoHeader={false} // optional, keeps "data has headers" checkbox off by default
      restartable // optional, lets user choose to upload another file when import is complete
      onComplete={handleComplete}
      /*onStart={({ file, preview, fields, columnFields }) => {
        // optional, invoked when user has mapped columns and started import
        prepMyAppForIncomingData();
      }}

      onClose={({ file, preview, fields, columnFields }) => {
        // optional, if this is specified the user will see a "Finish" button after import is done,
        // which will call this when clicked
        goToMyAppNextPage();
      }}*/

      // CSV options passed directly to PapaParse if specified:
      // delimiter={...}
      // newline={...}
      // quoteChar={...}
      // escapeChar={...}
      // comments={...}
      // skipEmptyLines={...}
      // delimitersToGuess={...}
      // chunkSize={...} // defaults to 10000
      // encoding={...} // defaults to utf-8, see FileReader API
    >
      <ImporterField name="day" label="Day" />
      <ImporterField name="sku" label="Sku" />
      <ImporterField name="commission_amount" label="Commission Amount" />
    </Importer>
  );
};

export default CSVImporterOverrideCommission;
